<template>
  <template-home-page></template-home-page>
</template>

<script lang="ts">

import templateHomePage from '@/app-template/lib/pages/HomePage.vue';

export default {
  name: "HomePage",
  components: { templateHomePage },
};
</script>